<template>
  <NuxtLink
    v-if="Object.keys(data).length"
    class="promo-preview"
    :to="localePath(data.is_external ? data.external_url : `/promotions/${data.term}`)"
  >
    <div v-if="data[$i18n.locale]" class="promo-preview__image-wrapper">
      <picture class="promo-preview__image">
        <source
          :srcset="$config.cloudUrl + data[$i18n.locale].background_image"
          media="(min-width: 800px)"
        />
        <img
          v-lazy="$config.cloudUrl + data[$i18n.locale].background_image_mobile"
          :src="$pixel"
          :alt="data[$i18n.locale].title"
          class="promo-preview__image"
          width="100"
          height="100"
        />
      </picture>
    </div>

    <UiTimer
      v-if="data.publication_end_date"
      :end-date="data.publication_end_date"
      class="promo-preview__counter"
    />

    <div class="promo-preview__bottom">
      <div class="promo-preview__text">
        <UiText
          v-if="text.title"
          :text="text.title"
          font="components-card-title"
          color="typography-title01"
          class="promo-preview__title"
        />
        <UiText
          v-if="text.text"
          :text="text.text"
          font="body-text"
          color="typography-body01"
          class="promo-preview__description"
        />
      </div>
      <UiBtn
        color="default"
        icon-only
        icon="chevrons/chevron-right"
        tag="div"
      />
    </div>
  </NuxtLink>
</template>

<script>
import UiTimer from '~/components/ui/UiTimer'

export default {
  name: 'CardPromotionPreview',
  components: {
    UiTimer,
  },
  props: {
    data: { type: Object },
  },
  computed: {
    text() {
      return {
        title: this.data[this.$i18n.locale]?.title,
        text: this.data[this.$i18n.locale]?.text,
      }
    },
    end() {
      let time = null
      if (this.data.publication_end_date) {
        time = Date.parse(this.data.publication_end_date)
      }
      else if (this.data.relativeDates?.publicationEndsIn) {
        time = new Date()
          .getTime() + this.data.relativeDates.publicationEndsIn
      }

      const days = ((new Date() - time) / (24 * 60 * 60 * 1000)) * -1

      return days < 1000 && days > 0 ? parseInt(days) : null
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
